<!-- main-header -->
<div class="main-header sticky side-header nav nav-item sticky-pin">
	<div class="container-fluid" style="padding-right: 10px;padding-left: 12px;">
		<div class="main-header-left ">
			<div class="app-sidebar__toggle mobile-toggle" data-toggle="sidebar">
				<!-- <a id="sidebar-open" name="sidebar-open" class="open-toggle" href="javascript:;"
					(click)="toggleSidebarOpen()">
					<i class="header-icon ti-menu tx-20 bg-transparent"></i>
				</a>
				<a id="sidebar-close" name="sidebar-close" class="close-toggle" href="javascript:;"
					(click)="toggleSidebarClose()">
					<i class="header-icons fe fe-x"></i>
				</a> -->
			</div>
			<div class="header-bar">
				<button class="back-button" *ngIf="showBackButton" (click)="navigateWithParams()">
				  <fa-icon [icon]="faArrowLeft"></fa-icon>
				</button>
				<h5 id="page-title" name="page-title" class="content-title_head" *ngIf="pageName">
				  {{ pageName }}
				</h5>
                <ng-container *ngTemplateOutlet="navigationPanel; context: { $implicit: pageName }"></ng-container>

			  </div>
			  
			<!-- <div class="main-header-center ml-3 d-sm-none d-md-none d-lg-block">
							<input type="search" class="form-control" placeholder="Search for anything...">
							<button class="btn"><i class="fas fa-search"></i></button>
						</div> -->
		</div>
		<div class="main-header-center">

			<!-- <div class="responsive-logo">
							<a routerLink="/dashboard"><img src="./assets/img/brand/logo.png" class="mobile-logo" alt="logo"></a>
 	</div> -->
		</div>
		<div class="main-header-right">
			<!-- <div class="mr-2" style="width: 160px"
				*ngIf="pageName=='Indoor Map' || pageName=='Outdoor Map' || pageName=='Composite Map' ||  pageName=='Home' || pageName=='IoA Dashboard' || pageName=='KPI Composite Map'">
				<label id="label-map" name="label-map" class="sites_clsd">Sites</label>
				<ng-select id="dropdown-technology" name="dropdown-technology" class="form-control custom_head_select"
					[searchable]="false" [(ngModel)]="technology" [ngModelOptions]="{standalone: true}"
					(change)="selectFloor($event)" placeholder="Select Site Location" style="padding: 0px;top: -4px;">
					<ng-option id="option-{{set}}" name="option-{{set}}" [value]="set"
						*ngFor="let set of mapList">{{set}}
					</ng-option>
				</ng-select>
			</div> -->
			<div>
				<app-action-buttons></app-action-buttons>
			</div>




			<!-- <div class="mr-2" style="width: 160px;margin: 0;font-size: 12px;"  *ngIf="pageName !='Deployment'">
							<label id="label-map" name="label-map">Deployment</label>
							<ng-select id="dropdown-technology" name="dropdown-technology" class="form-control custom_head_select" [searchable]="false" [(ngModel)]="selectedDeployment"
							  [ngModelOptions]="{standalone: true}" (change)="selectDeployment($event)" placeholder="Select Type" style="padding: 0px;    position: relative !important;top: -3px;">
							Set WiFi  <ng-option id="option-{{set}}" name="option-{{set}}" [value]="set.id" *ngFor="let set of deploymentList">{{set.name}}
							  </ng-option>
							</ng-select>
						  </div>  -->
			<!-- <div class="form-group time_x" >
							<label id="label-timezone" name="label-timezone">Time Zone </label> -->

			<!-- [ngModel]="selectedTz" -->
			<!-- <select id="dropdown-timezone" name="dropdown-timezone" name="timeZone" class="select-css" [(ngModel)]="selectedTz"  (ngModelChange)="timeZoneChanged($event)">
							  <option id="option-{{tz}}" name="option-{{tz}}" *ngFor="let tz of tzNames" [value]="tz">
								{{ tz }}
							  </option>
							</select>
						  </div> -->
						  <button *ngIf="displayCustomizeChart" class="btn btn-outline-primary" style="display: flex; align-items: center;gap: 5px;" (click)="openChartConfig(chartConfigModal)">
							<mat-icon>tune</mat-icon> Customize Chart
						  </button>
						  <a  class="new nav-link p-0">
							 <span *ngIf="theme=='light-theme'" id="dark-theme" name="dark-theme" (click)="toggleTheme('dark-theme')" class="dark-layout p-2 curser-pointer"><i  class="fe fe-moon f-16"></i></span>
							 <span   *ngIf="theme=='dark-theme'" id="light-theme" name="light-theme" (click)="toggleTheme('light-theme')" class="light-layout p-2 curser-pointer"><i  class="fe fe-sun f-16"></i></span></a>
				<div class="nav-item full-screen fullscreen-button">
				<a id="button-fullscreen" name="button-fullscreen" class="new nav-link full-screen-link" (click)="setFullScreenClass()"
					href="javascript:;" appFullscreen>
					<i class=" fe fe-maximize"></i>
				</a>
			</div>
			

			<div style="text-align: end;padding: 0px;margin-right: 10px;" >
				<app-datetime-range-picker [onlyTimezone]="hideDaterange"  [showTimezone]="true"  (dateRange)="getdateRange($event)"  (sendTimeZone)="sendTimeZone($event)" ></app-datetime-range-picker>
			</div>

			<!-- <div class="nav nav-item  navbar-nav-right ml-auto">
							<div ngbDropdown class="navbar-form nav-item my-auto d-none d-md-block d-sm-block d-lg-none ">
								<a ngbDropdownToggle class="nav-item ">
									<i class="ti-search"></i>
								</a>
								<div ngbDropdownMenu>
									<div class="main-form-search p-2">
										<div class="input-group">
											<div class="input-group-btn search-panel">
												<ng-select id="dropdown-categories" name="dropdown-categories" placeholder="All categories" class="form-control p-0">
													<ng-option *ngFor="let category of categories" id="option-{{category.name}}" name="option-{{category.name}}" [value]="category.id">
														{{category.name}}
													</ng-option>
												</ng-select>
											</div>
											<input type="search" class="form-control" placeholder="Search for anything...">
											<button class="btn search-btn"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></button>
										</div>
									</div>
								</div>
							</div> -->



			<div ngbDropdown class="nav-item main-header-notification">
				<button ngbDropdownToggle class="position-relative mr-2 bg-transparent border-0 mt-1" style="height: 20px;width: 20px;"
				>
				<fa-icon [icon]="faBell" class="position-absolute top-50 start-50 translate-middle"
					style="color: #5965F9; font-size: 20px;"></fa-icon>
				<span  *ngIf="notificationCount&&notificationCount>0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger p-1">
					{{notificationCount>10?'10+':notificationCount}}
					<span class="visually-hidden">Unread Messages</span>
				</span>
			</button>
				<div ngbDropdownMenu class="dropdown-menu-arrow animated fadeInUp ">
					<div class="main-dropdown-header  d-sm-none">
						<a class="main-header-arrow"><i class="icon ion-md-arrow-back"></i></a>
					</div>
					<div class="menu-header-content text-left d-flex">
						<div class="my-auto">
							<h6 class="menu-header-title text-white mb-0">
								<span *ngIf="notifications && notifications.length !=0">
									{{notificationCount}}
	
								</span>New Notifications
							</h6>
						</div>
					</div>
					<div class="main-notification-list Notification-scroll"
						
						style="height: 292px !important;overflow: hidden;">
						<ng-container *ngFor="let notify of notifications">
							<a ngbDropdownItem (click)="redirectToCnfogurationpage()" class="p-2 d-flex border-bottom curser-pointer">
								<div class="notifyimg bg-primary-transparent" style="height: 40px;">
									<i class="la la-check-circle text-primary"></i>
								</div>
								<div class="ml-2">
									<h5 class="notification-label mb-1" style="text-transform: capitalize;">
										{{notify._source.name}}</h5>
									<div class="notification-subtext"><span>Device Name : {{notify?._source.name}} </span> </div>
									<div class="notification-subtext"> <span>{{notify?._source._kuzzle_info?.createdAt | timeAgo}}</span>
									</div>
								</div>
							</a>
						</ng-container>
					</div>
					<div *ngIf="notifications && notifications.length == 0">
						<p class="text-center mt-2 mb-0"> No Notification Available</p>
					</div>
					<div ngbDropdownItem (click)="redirectToCnfogurationpage()" class="text-center dropdown-footer "
						style="cursor: pointer;">
						<a>VIEW ALL</a>
					</div>
				</div>
			</div>

			
			


			<div ngbDropdown class="nav-item main-header-message header-contact" style="display: none;">
				<a ngbDropdownToggle class="new nav-link">
					<i class="ti-email"></i><span class=" pulse-danger"></span>
				</a>
				<div ngbDropdownMenu class=" dropdown-menu-arrow animated fadeInUp ">
					<div class="main-dropdown-header  d-sm-none">
						<a class="main-header-arrow" href="javascript:;"><i class="icon ion-md-arrow-back"></i></a>
					</div>
					<div class="menu-header-content text-left d-flex">
						<div class="my-auto">
							<h6 class="menu-header-title text-white mb-0">5 New Messages</h6>
						</div>
						<div class="my-auto ml-auto">
							<span class="badge badge-pill badge-warning float-right">Mark All Read</span>
						</div>
					</div>
					<div class="main-message-list chat-scroll">
						<a href="javascript:;" class="p-3 m-1 d-flex border-bottom">
							<div style="position: relative;">
								<img class="drop-img cover-image" src="./assets/img/1.jpg">
								<span class="avatar-status bg-teal"></span>
							</div>
							<div class="wd-90p">
								<div class="d-flex">
									<h5 class="mb-1 name">Paul Molive</h5>
									<p class="time mb-0 text-right ml-auto float-right">10 min ago</p>
								</div>
								<p class="mb-0 desc">I'm sorry but i'm not sure how...</p>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div style="position: relative;">
								<img class="drop-img cover-image" src="./assets/img/1.jpg">
								<span class="avatar-status bg-teal"></span>
							</div>
							<div class="wd-90p">
								<div class="d-flex">
									<h5 class="mb-1 name">Sahar Dary</h5>
									<p class="time mb-0 text-right ml-auto float-right">13 min ago</p>
								</div>
								<p class="mb-0 desc">All set ! Now, time to get to you now......</p>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div style="position: relative;">
								<img class="drop-img cover-image" src="./assets/img/1.jpg">
								<span class="avatar-status bg-teal"></span>
							</div>
							<div class="wd-90p">
								<div class="d-flex">
									<h5 class="mb-1 name">Khadija Mehr</h5>
									<p class="time mb-0 text-right ml-auto float-right">20 min ago</p>
								</div>
								<p class="mb-0 desc">Are you ready to pickup your Delivery...</p>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div style="position: relative;">
								<img class="drop-img cover-image" src="./assets/img/1.jpg">
								<span class="avatar-status bg-danger"></span>
							</div>
							<div class="wd-90p">
								<div class="d-flex">
									<h5 class="mb-1 name">Barney Cull</h5>
									<p class="time mb-0 text-right ml-auto float-right">30 min ago</p>
								</div>
								<p class="mb-0 desc">Here are some products ...</p>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div style="position: relative;">
								<img class="drop-img cover-image" src="./assets/img/1.jpg">
								<span class="avatar-status bg-teal"></span>
							</div>
							<div class="wd-90p">
								<div class="d-flex">
									<h5 class="mb-1 name">Petey Cruiser</h5>
									<p class="time mb-0 text-right ml-auto float-right">35 min ago</p>
								</div>
								<p class="mb-0 desc">I'm sorry but i'm not sure how...</p>
							</div>
						</a>
					</div>
					<div class="text-center dropdown-footer">
						<a href="javascript:;">VIEW ALL</a>
					</div>
				</div>
			</div>
			<div ngbDropdown class="nav-item main-header-notification" style="display: none;">
				<a ngbDropdownToggle class="new nav-link">
					<i class="ti-bell animated bell-animations"></i><span class=" pulse"></span>
				</a>
				<div ngbDropdownMenu class=" dropdown-menu-arrow animated fadeInUp ">
					<div class="main-dropdown-header  d-sm-none">
						<a class="main-header-arrow" href="javascript:;"><i class="icon ion-md-arrow-back"></i></a>
					</div>
					<div class="menu-header-content text-left d-flex">
						<div class="my-auto">
							<h6 class="menu-header-title text-white mb-0">7 New Notifications</h6>
						</div>
						<div class="my-auto ml-auto">
							<span class="badge badge-pill badge-warning float-right">Mark All Read</span>
						</div>
					</div>
					<div class="main-notification-list Notification-scroll">
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div class="notifyimg bg-success-transparent">
								<i class="la la-shopping-basket text-success"></i>
							</div>
							<div class="ml-3">
								<h5 class="notification-label mb-1">New Order Received</h5>
								<div class="notification-subtext">1 hour ago</div>
							</div>
							<div class="ml-auto">
								<i class="las la-angle-right text-right text-muted"></i>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div class="notifyimg bg-danger-transparent">
								<i class="la la-user-check text-danger"></i>
							</div>
							<div class="ml-3">
								<h5 class="notification-label mb-1">22 verified registrations</h5>
								<div class="notification-subtext">2 hour ago</div>
							</div>
							<div class="ml-auto">
								<i class="las la-angle-right text-right text-muted"></i>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div class="notifyimg bg-primary-transparent">
								<i class="la la-check-circle text-primary"></i>
							</div>
							<div class="ml-3">
								<h5 class="notification-label mb-1">Project has been approved</h5>
								<div class="notification-subtext">4 hour ago</div>
							</div>
							<div class="ml-auto">
								<i class="las la-angle-right text-right text-muted"></i>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div class="notifyimg bg-pink-transparent">
								<i class="la la-file-alt text-pink"></i>
							</div>
							<div class="ml-3">
								<h5 class="notification-label mb-1">New files available</h5>
								<div class="notification-subtext">10 hour ago</div>
							</div>
							<div class="ml-auto">
								<i class="las la-angle-right text-right text-muted"></i>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div class="notifyimg bg-warning-transparent">
								<i class="la la-envelope-open text-warning"></i>
							</div>
							<div class="ml-3">
								<h5 class="notification-label mb-1">New review received</h5>
								<div class="notification-subtext">1 day ago</div>
							</div>
							<div class="ml-auto">
								<i class="las la-angle-right text-right text-muted"></i>
							</div>
						</a>
						<a href="javascript:;" class="p-3 d-flex border-bottom">
							<div class="notifyimg bg-purple-transparent">
								<i class="la la-gem text-purple"></i>
							</div>
							<div class="ml-3">
								<h5 class="notification-label mb-1">Updates Available</h5>
								<div class="notification-subtext">2 days ago</div>
							</div>
							<div class="ml-auto">
								<i class="las la-angle-right text-right text-muted"></i>
							</div>
						</a>
					</div>
					<div class="text-center dropdown-footer">
						<a href="javascript:;">VIEW ALL</a>
					</div>
				</div>
			</div>
			<div ngbDropdown class=" main-profile-menu nav nav-item nav-link pr-0">
				<a ngbDropdownToggle id="avatar-image" name="avatar-image" class="d-flex profile-user"
					href="javascript:void(0)">
					<img *ngIf="theme=='light-theme'" alt="avatar" src="./assets/img/blue-logo.png">
					<img alt="avatar" *ngIf="theme=='dark-theme'" src="./assets/img/white-logo.png">
				</a>
				<div ngbDropdownMenu class="dropdown-menu-arrow animated fadeInUp">
					<div class="main-header-profile header-img">
						<div id="user-image" name="user-image" class="main-img-user">
						  <img src="./assets/img/blue-logo.png" alt="User Image" />
						</div>
						<div class="user-info">
						  <h6 class="user-name">Name: {{ full_name || "VIAVI" | uppercase }}</h6>
						  <h6 class="user-id mt-1">username: {{ user_id || "--" }}</h6>
						</div>
					  </div>
					  
					<!-- <a ngbDropdownItem class="border-top" style="color:#c0c6e6 !important" routerLink="/pages/profile">
									
										<i class="far fa-user"></i> My Profile
									</a> -->
					<!-- <a ngbDropdownItem class="dropdown-item" routerLink="/pages/profile" style="color:#c0c6e6 !important">
									
										<i class="far fa-edit"></i> Edit Profile
									</a> -->
					<!-- <a ngbDropdownItem style="color:#c0c6e6 !important" routerLink="/pages/profile">
									 
										<i class="far fa-clock"></i>  Activity Logs
									</a> -->
					<!-- <a ngbDropdownItem style="color:#c0c6e6 !important"  routerLink="/pages/profile">
									
										<i class="fas fa-sliders-h"></i> Account Settings
									</a> -->
					<a ngbDropdownItem id="change-password" name="change-password" [disabled]="startegy != 'local'" style="margin-top: 8px;
									margin-bottom: 5px;" (click)="redirect();">
						<i class="fas fa-key"></i> Change Password
					</a>
					<a ngbDropdownItem id="sign-out" name="sign-out"  routerLink="/login" (click)="logOut()">
						<i class="fas fa-sign-out-alt"></i> Sign Out
					</a>
				</div>
			</div>
			<button class="navbar-toggler navresponsive-toggler d-sm-none" type="button" type="button"
				(click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" style="display: none;">
				<span class="navbar-toggler-icon fe fe-more-vertical "></span>
			</button>
			<div class="dropdown main-header-message right-toggle" style="display: none;">
				<a href="javascript:void(0)" class="nav-link " (click)="toggleSidebarNotification()">
					<i class="ti-menu tx-20 bg-transparent"></i>
				</a>
			</div>
		</div>
	</div>
</div>
<!-- </div> -->
<!-- /main-header -->

<!-- mobile-header -->
<div class="responsive main-header">
	<div class="mb-1 navbar navbar-expand-lg  nav nav-item  navbar-nav-right responsive-navbar navbar-dark d-sm-none ">
		<div class="collapse navbar-collapse" id="navbarSupportedContent-4" #collapse="ngbCollapse"
			[(ngbCollapse)]="isCollapsed">
			<div class="d-flex order-lg-2 ml-auto">
				<div ngbDropdown class="navbar-form nav-item my-auto d-lg-none">
					<a ngbDropdownToggle class="nav-item ">
						<i class="ti-search"></i>
					</a>
					<div ngbDropdownMenu>
						<div class="main-form-search p-2">
							<div class="input-group">
								<div class="input-group-btn search-panel">
									<ng-select placeholder="All categories" class="form-control p-0">
										<ng-option *ngFor="let category of categories" [value]="category.id">
											{{category.name}}
										</ng-option>
									</ng-select>
								</div>
								<input type="search" class="form-control" placeholder="Search for anything...">
								<button class="btn search-btn"><svg xmlns="http://www.w3.org/2000/svg" width="20"
										height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
										stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-search">
										<circle cx="11" cy="11" r="8"></circle>
										<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
									</svg></button>
							</div>
						</div>
					</div>
				</div>
				<div class="nav-item full-screen fullscreen-button d-md-flex">
					<a class="new nav-link full-screen-link" href="javascript:;" appFullscreen>
						<i class=" fe fe-maximize"></i>
					</a>
				</div>
				<div ngbDropdown class="nav-item main-header-message header-contact">
					<a ngbDropdownToggle class="new nav-link">
						<i class="ti-email"></i><span class=" pulse-danger"></span>
					</a>
					<div ngbDropdownMenu class=" dropdown-menu-arrow animated fadeInUp ">
						<div class="main-dropdown-header  d-sm-none">
							<a class="main-header-arrow" href="javascript:;"><i class="icon ion-md-arrow-back"></i></a>
						</div>
						<div class="menu-header-content text-left d-flex">
							<div class="my-auto">
								<h6 class="menu-header-title text-white mb-0">5 New Messages</h6>
							</div>
							<div class="my-auto ml-auto">
								<span class="badge badge-pill badge-warning float-right">Mark All Read</span>
							</div>
						</div>
						<div class="main-message-list chat-scroll">
							<a href="javascript:;" class="p-3 m-1 d-flex border-bottom">
								<div style="position: relative;">
									<img class="drop-img cover-image" src="./assets/img/1.jpg">
									<span class="avatar-status bg-teal"></span>
								</div>
								<div class="wd-90p">
									<div class="d-flex">
										<h5 class="mb-1 name">Paul Molive</h5>
										<p class="time mb-0 text-right ml-auto float-right">10 min ago</p>
									</div>
									<p class="mb-0 desc">I'm sorry but i'm not sure how...</p>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div style="position: relative;">
									<img class="drop-img cover-image" src="./assets/img/1.jpg">
									<span class="avatar-status bg-teal"></span>
								</div>
								<div class="wd-90p">
									<div class="d-flex">
										<h5 class="mb-1 name">Sahar Dary</h5>
										<p class="time mb-0 text-right ml-auto float-right">13 min ago</p>
									</div>
									<p class="mb-0 desc">All set ! Now, time to get to you now......</p>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div style="position: relative;">
									<img class="drop-img cover-image" src="./assets/img/1.jpg">
									<span class="avatar-status bg-teal"></span>
								</div>
								<div class="wd-90p">
									<div class="d-flex">
										<h5 class="mb-1 name">Khadija Mehr</h5>
										<p class="time mb-0 text-right ml-auto float-right">20 min ago</p>
									</div>
									<p class="mb-0 desc">Are you ready to pickup your Delivery...</p>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div style="position: relative;">
									<img class="drop-img cover-image" src="./assets/img/1.jpg">
									<span class="avatar-status bg-danger"></span>
								</div>
								<div class="wd-90p">
									<div class="d-flex">
										<h5 class="mb-1 name">Barney Cull</h5>
										<p class="time mb-0 text-right ml-auto float-right">30 min ago</p>
									</div>
									<p class="mb-0 desc">Here are some products ...</p>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div style="position: relative;">
									<img class="drop-img cover-image" src="./assets/img/1.jpg">
									<span class="avatar-status bg-teal"></span>
								</div>
								<div class="wd-90p">
									<div class="d-flex">
										<h5 class="mb-1 name">Petey Cruiser</h5>
										<p class="time mb-0 text-right ml-auto float-right">35 min ago</p>
									</div>
									<p class="mb-0 desc">I'm sorry but i'm not sure how...</p>
								</div>
							</a>
						</div>
						<div class="text-center dropdown-footer">
							<a href="javascript:;">VIEW ALL</a>
						</div>
					</div>
				</div>
				<div ngbDropdown class="nav-item main-header-notification">
					<a ngbDropdownToggle class="new nav-link">
						<i class="ti-bell animated bell-animations"></i><span class=" pulse"></span>
					</a>
					<div ngbDropdownMenu class=" dropdown-menu-arrow animated fadeInUp ">
						<div class="main-dropdown-header  d-sm-none">
							<a class="main-header-arrow" href="javascript:;"><i class="icon ion-md-arrow-back"></i></a>
						</div>
						<div class="menu-header-content text-left d-flex">
							<div class="my-auto">
								<h6 class="menu-header-title text-white mb-0">7 New Notifications</h6>
							</div>
							<div class="my-auto ml-auto">
								<span class="badge badge-pill badge-warning float-right">Mark All Read</span>
							</div>
						</div>
						<div class="main-notification-list Notification-scroll">
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div class="notifyimg bg-success-transparent">
									<i class="la la-shopping-basket text-success"></i>
								</div>
								<div class="ml-3">
									<h5 class="notification-label mb-1">New Order Received</h5>
									<div class="notification-subtext">1 hour ago</div>
								</div>
								<div class="ml-auto">
									<i class="las la-angle-right text-right text-muted"></i>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div class="notifyimg bg-danger-transparent">
									<i class="la la-user-check text-danger"></i>
								</div>
								<div class="ml-3">
									<h5 class="notification-label mb-1">22 verified registrations</h5>
									<div class="notification-subtext">2 hour ago</div>
								</div>
								<div class="ml-auto">
									<i class="las la-angle-right text-right text-muted"></i>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div class="notifyimg bg-primary-transparent">
									<i class="la la-check-circle text-primary"></i>
								</div>
								<div class="ml-3">
									<h5 class="notification-label mb-1">Project has been approved</h5>
									<div class="notification-subtext">4 hour ago</div>
								</div>
								<div class="ml-auto">
									<i class="las la-angle-right text-right text-muted"></i>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div class="notifyimg bg-pink-transparent">
									<i class="la la-file-alt text-pink"></i>
								</div>
								<div class="ml-3">
									<h5 class="notification-label mb-1">New files available</h5>
									<div class="notification-subtext">10 hour ago</div>
								</div>
								<div class="ml-auto">
									<i class="las la-angle-right text-right text-muted"></i>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div class="notifyimg bg-warning-transparent">
									<i class="la la-envelope-open text-warning"></i>
								</div>
								<div class="ml-3">
									<h5 class="notification-label mb-1">New review received</h5>
									<div class="notification-subtext">1 day ago</div>
								</div>
								<div class="ml-auto">
									<i class="las la-angle-right text-right text-muted"></i>
								</div>
							</a>
							<a href="javascript:;" class="p-3 d-flex border-bottom">
								<div class="notifyimg bg-purple-transparent">
									<i class="la la-gem text-purple"></i>
								</div>
								<div class="ml-3">
									<h5 class="notification-label mb-1">Updates Available</h5>
									<div class="notification-subtext">2 days ago</div>
								</div>
								<div class="ml-auto">
									<i class="las la-angle-right text-right text-muted"></i>
								</div>
							</a>
						</div>
						<div class="text-center dropdown-footer">
							<a href="javascript:;">VIEW ALL</a>
						</div>
					</div>
				</div>
				<div ngbDropdown class=" main-profile-menu nav nav-item nav-link pr-0">
					<a ngbDropdownToggle class="d-flex profile-user" href="javascript:void(0)">
						<img alt="avatar" src="./assets/img/1.jpg">
					</a>
					<div ngbDropdownMenu class="dropdown-menu-arrow animated fadeInUp">
						<div class="main-header-profile header-img">
							<div class="main-img-user"><img alt="" src="./assets/img/1.jpg"></div>
							<h6>VIAVI</h6>
							<!-- <span>Premium Member</span> -->
						</div>
						<a ngbDropdownItem class="border-top" routerLink="/pages/profile">
							<i class="far fa-user"></i> My Profile
						</a>
						<a ngbDropdownItem class="dropdown-item" routerLink="/pages/profile">
							<i class="far fa-edit"></i> Edit Profile
						</a>
						<a ngbDropdownItem class="" routerLink="/pages/profile">
							<i class="far fa-clock"></i> Activity Logs
						</a>
						<a ngbDropdownItem class="" routerLink="/pages/profile">
							<i class="fas fa-sliders-h"></i> Account Settings
						</a>
						<a ngbDropdownItem class="" routerLink="/login">
							<i class="fas fa-sign-out-alt"></i> Sign Out
						</a>
					</div>
				</div>
				<div class="dropdown main-header-message right-toggle">
					<a href="javascript:void(0)" class="nav-link " (click)="toggleSidebarNotification()">
						<i class="ti-menu tx-20 bg-transparent"></i>
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- mobile-header -->


<ng-template #content let-modal>
	<!-- <app-draggble-popup [dragHolder]="header"> -->
	<div class="d-flex flex-column h-100">
		<div class="modal-header">
			<h4 #header class="modal-title w-100" id="modal-basic-title"> Asset Configuration</h4>
			<button type="button" class="close" aria-label="Close" (click)="refresh();modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>

		<div class="modal-body flex-grow-1 overlay_spinner-parent">
			<app-create-network-model></app-create-network-model>

		</div>
	</div>
	<!-- </app-draggble-popup> -->
	<div class="modal-footer">
		<button type="button" class="btn ripple btn-danger"
			(click)="refresh();modal.dismiss('Close click')">Close</button>
	</div>
</ng-template>
<ng-template #chartConfigModal let-modal>
<div class="customize-chart">
	<div class="modal-header">
		<h2 mat-dialog-title>Chart Customization</h2>
		<button id="model-dismiss-cross" name="model-dismiss-cross" type="button" class="close" data-dismiss="modal"
			aria-label="Close" (click)="handleModalDismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<!-- <ng-select style="width: 130px;" [items]="chartTypes" bindLabel="label"
						[(ngModel)]="selectedChartType" (change)="onChartTypeChange()" placeholder="Select a chart type"
						[clearable]="false">
					</ng-select>  -->
	<div class="modal-body chart-config-dialog">
		<!-- Chart Type Selection -->
  <!-- Chart Type Selection with Tick Mark -->
  <mat-button-toggle-group [(ngModel)]="selectedChartType" (change)="onChartTypeChange()" class="toggle-group">
	<mat-button-toggle *ngFor="let type of chartTypes" [value]="type.value" class="toggle-btn">
	  <span class="toggle-content">
		  <mat-icon *ngIf="selectedChartType === type.value" class="tick-mark">check</mat-icon>
		  <mat-icon class="icon">{{ type.icon }}</mat-icon>
		  <span style="font-weight: 600;">{{ type.label }}</span>
	  </span>
	</mat-button-toggle>
  </mat-button-toggle-group>
  <hr>
  
  <!-- Show/Hide Markers (Only for AREA & LINE Charts) -->
  <div *ngIf="selectedChartType === 'area' || selectedChartType === 'line'" class="marker-options">
	<mat-slide-toggle color="primary" [(ngModel)]="showMarkers" (change)="toggleMarkers()">Show Data Points (Markers)</mat-slide-toggle>
  
	<!-- Marker Size -->
	<div *ngIf="showMarkers">
	  <label>Data points size</label>
	  <mat-slider color="primary" min="2" max="10" step="1" [(ngModel)]="markerSize" (change)="onChartTypeChange()"></mat-slider>
	</div>
  </div>
  
  <!-- Stroke Size -->
  <div class="stroke-size">
	<label>Line width</label>
	<mat-slider color="primary" min="0" max="10" step="0.5" [(ngModel)]="strokeSize" (change)="onChartTypeChange()"></mat-slider>
  </div>
	</div>
	<div class="modal-footer">
		<!-- <button id="model-close-btn" name="model-close-btn" type="button" class="btn btn-primary"
			(click)="modal.dismiss('Cross click');">Reset</button> -->
			<button id="model-close-btn" name="model-close-btn" type="button" class="btn btn btn-outline-primary" (click)="resetChart()">Reset</button>
		<button id="model-update-btn" name="model-update-btn" type="button" class="btn btn-primary"
			(click)="applyChartConfig(chartConfigModal)">Apply</button>
	</div>
  </div>
  </ng-template>

  <ng-template #navigationPanel  let-data >
					  <span *ngIf="pageToRedirectionMap?.[data]">
                                                        <button mat-icon-button [matMenuTriggerFor]="menu" style="width: 23px">
                                                          <mat-icon>more_vert</mat-icon>
                                                        </button>
                                                
                                                        <mat-menu #menu="matMenu">
                                                          <button mat-menu-item
														   style="height:max-content"
														   (click)="navigateToPage(pages?.url)"
														    *ngFor="let pages of pageToRedirectionMap?.[data]" >
															<fa-icon [icon]="pages?.icon" [ngClass]="['mr-2', pages?.classname]" style="font-size:1.5em" ></fa-icon>
                                                            <!-- <mat-icon class="telemetry-icon">{{show_chart}}</mat-icon> -->
                                                            <span class="telemetry-text">{{pages?.name}}</span>
															<fa-icon [icon]="faArrowRight" [ngClass]="['ml-2 ', 'text-secondary']" style="font-size:1em" ></fa-icon>
                                                          </button>
                                                        </mat-menu>
				</span>
  </ng-template>